import { AxiosInstance } from "axios";
import { useContext, useEffect, useState } from "react";
import httpClientFactory from "../config/httpConfig";
import { AppConfig } from "../context/context";
import { IOrganizationModel, numberToOrgType } from "../models/organizations.model";

const TENANTS_ENDPOINT = "v1/DevTenants";

interface UpdateOrgOpts {
  orgId: string;
  displayName?: string;
  locale?: string;
  mfa?: any;
}

interface IOrganizationService {
  getAllTenantApps: (name: string) => Promise<any>;
  getOrg: (orgName: string) => Promise<any>;
  updateOrg: ({ orgId, displayName, locale, mfa }: UpdateOrgOpts) => Promise<any>;
  getOrgAvailableFeatures: (orgName: string) => Promise<any>;
  putOrgAvailableFeatures: (orgName: string,data: any) => Promise<any>;
  getOrgBillingMode: (orgName: string) => Promise<any>;
}

export const OrganizationService = (config: any): IOrganizationService => {
  const http: AxiosInstance = httpClientFactory(config);
  
  return {
    getAllTenantApps: (name) => {
      return http
        .get(`${TENANTS_ENDPOINT}/${name}/applications`);
    },
   updateOrg: ({ orgId, displayName, locale, mfa }: UpdateOrgOpts) => {
      const payload = mfa != null
        ? { enableMFA: mfa.enableMFA, typeMFA: mfa.typeMFA }
        : { displayName, locale };
      return http.put(`${TENANTS_ENDPOINT}/${orgId}`, payload);
    },
    getOrg: async (orgName) => {
        return await http
            .get(`${TENANTS_ENDPOINT}/${orgName}`)
            .then((response: any) => tenantViewToOrg(response));
    },
    getOrgAvailableFeatures: (orgName) => {
      return http.get(`${TENANTS_ENDPOINT}/${orgName}/features/available`);
    },
    putOrgAvailableFeatures: (orgName, data) => {
      return http.put(`${TENANTS_ENDPOINT}/${orgName}/features/available`, data);
    },
  
    getOrgBillingMode: (orgName: string) => {
      return http
        .get(`${TENANTS_ENDPOINT}/${orgName}/billing-mode`);
    }
  };
};

const tenantViewToOrg = (org: any): IOrganizationModel => {
  return {
    id: org.name,
    name: org.name,
    displayName: org.displayName ? org.displayName : org.name,
    status: org.isActivated,
    type: numberToOrgType(org.type),
    referenceId: org.billingDefinitions ? org.billingDefinitions[0]?.referenceId : "",
    email: org.adminEmail ? org.adminEmail : "",
    url: org.url,
    locale: org.locale,
    applications: org.applications,
    notifyUsers: org.notifyUsers,
    enableMFA: org.enableMFA,
    typeMFA: org.typeMFA
  };
};

export function useOrgService() {
  const { config } = useContext(AppConfig);
  const [orgService, setOrgService] = useState<IOrganizationService>(
    {} as IOrganizationService
  );

  if (!config) {
    console.log("Error NoConfig")
    throw new Error("useOrgServices hook must be used inside AppConfig context");
  }

  useEffect(() => {
    const { baseUrl, tenantId, token } = config;
    if (!baseUrl || !tenantId || !token) return;
    setOrgService(OrganizationService({ baseUrl, tenantId, token }));
  }, [config]);

  return {
    orgService,
  };
}

export default OrganizationService;
